      // js start for vertical slider in product thumbnail images
      $(document).ready(function() {
        // Initialize Swiper instances
        const sliderThumbs = new Swiper('.slider__thumbs .swiper-container', {
          direction: 'vertical',
          slidesPerView: 4,
          spaceBetween: 10,
          noSwiping: true, // Disable swiping
          noSwipingClass: 'swiper-no-swiping', // Apply this class to prevent swiping
          navigation: {
            nextEl: '.slider__next',
            prevEl: '.slider__prev'
          },
          freeMode: false,
          breakpoints: {
            0: {
              direction: 'horizontal',
            },
            1110: {
              direction: 'vertical',
            }
          }
        });

        const sliderImages = new Swiper('.slider__images .swiper-container', {

          mousewheel: false,
          navigation: {
            nextEl: '.slider_next',
            prevEl: '.slider_prev'
          },
          grabCursor: true,
          thumbs: {
            swiper: sliderThumbs
          },
          breakpoints: {
            0: {
              direction: 'horizontal',
              slidesPerView: 2,      
              spaceBetween: 10       
            },
            768: {
              direction: 'horizontal',
              slidesPerView: 2,
              spaceBetween: 20
            },
            1110: {
              direction: 'vertical',
              slidesPerView: 1,

            }
          }
        });

        // Only scroll gallery with wheel when hovering over the image itself (not the white space)
        // Cooldown so one wheel tick = one image (prevents spinning through multiple images)
        const sliderImagesEl = document.querySelector('.slider__images .swiper-container');
        var galleryWheelCooldown = 0;
        var galleryWheelCooldownMs = 400;
        if (sliderImagesEl) {
          sliderImagesEl.addEventListener('wheel', function(e) {
            const overImage = e.target.closest('.slider__image');
            if (!overImage || !overImage.closest('.slider__images')) return;
            if (Date.now() < galleryWheelCooldown) {
              e.preventDefault();
              return;
            }
            e.preventDefault();
            if (e.deltaY > 0) {
              sliderImages.slideNext();
            } else if (e.deltaY < 0) {
              sliderImages.slidePrev();
            }
            galleryWheelCooldown = Date.now() + galleryWheelCooldownMs;
          }, { passive: false });
        }

        function findCurrentThumbnailIndex() {
          const thumbnails = document.querySelectorAll('.slider__thumbs .swiper-slide');
          for (let i = 0; i < thumbnails.length; i++) {
            if (thumbnails[i].getAttribute('aria-current') === 'true') {
              // Remove aria-current="true" from the previous active thumbnail
              thumbnails[i].removeAttribute('aria-current');
            }
            if (thumbnails[i].getAttribute('aria-current') === 'true') {
              sliderImages.slideTo(i);
              const imageSlides = document.querySelectorAll('.slider__images .swiper-slide');
              // Add aria-current="true" to the corresponding slide in the slider__images Swiper
              imageSlides[i].setAttribute('aria-current', 'true');
              return i;
            }
          }
          return 0; // Default to the first thumbnail if none found
        }

        // Set the initial slide index based on the current thumbnail with aria-current="true"
        const initialThumbIndex = findCurrentThumbnailIndex();
        sliderImages.slideTo(initialThumbIndex);

        // Function to synchronize slider__thumbs and slider__images on thumbnail click
        function synchronizeThumbnailsAndImages(thumbIndex) {
          // Synchronize slider__thumbs and slider__images
          sliderThumbs.slideTo(thumbIndex);
          sliderImages.slideTo(thumbIndex);

          // Set aria-current="true" on the clicked thumbnail and corresponding slide in slider__images
          const thumbnails = document.querySelectorAll('.slider__thumbs .swiper-slide');
          const imageSlides = document.querySelectorAll('.slider__images .swiper-slide');
          for (let i = 0; i < thumbnails.length; i++) {
            if (i === thumbIndex) {
              thumbnails[i].setAttribute('aria-current', 'true');
              imageSlides[i].setAttribute('aria-current', 'true');
            } else {
              thumbnails[i].removeAttribute('aria-current');
              imageSlides[i].removeAttribute('aria-current');
            }
          }
        }

        // Add click event listener to thumbnails
        $('.slider__thumbs .swiper-slide').on('click', function() {
          const thumbIndex = $(this).index();
          synchronizeThumbnailsAndImages(thumbIndex);
        });

        // Set initial aria-current="true" for the first thumbnail and slide
        $('.slider__thumbs .swiper-slide:first-child').attr('aria-current', 'true');
        $('.slider__images .swiper-slide:first-child').attr('aria-current', 'true');

        sliderImages.on('slideChange', function() {
          const currentIndex = sliderImages.realIndex;
          synchronizeThumbnailsAndImages(currentIndex);

          // Add aria-current="true" to the corresponding thumbnail
          const thumbnails = document.querySelectorAll('.slider__thumbs .swiper-slide');
          for (let i = 0; i < thumbnails.length; i++) {
            if (i === currentIndex) {
              thumbnails[i].setAttribute('aria-current', 'true');
               console.log(thumbnails[i]);
            } else {
              const thumbnails = document.querySelectorAll('.slider__thumbs .swiper-slide .slider__image .thumbnail');
                thumbnails.forEach(thumbnail => {
                    thumbnail.removeAttribute('aria-current');
                });
              thumbnails[i].removeAttribute('aria-current');
            }
          }
        });

        // Click event listener for the color button
        $(document).on('click', 'input[type="radio"].Color-btn', function() {
          sliderImages.slideTo(0); // Slide to the top (index 0) every time the button is clicked
          const thumbnails = document.querySelectorAll('.slider__thumbs .swiper-slide');
          thumbnails.forEach(thumbnail => {
            thumbnail.removeAttribute('aria-current');
          });
        });
      });
          // // js end for vertical slider in product thumbnail images